import React from "react";
import "./About.css";
import Sunil from "../../../assests/SunilBabu.webp";
import DilipV from "../../../assests/Dilip.webp";
import Ankesh from "../../../assests/Ankesh.webp";
import Rajamouli from "../../../assests/SS-rajamouli.webp";
import ChetaSharma from "../../../assests/Chetan-Sharma.webp";

import { NavLink } from "react-router-dom";

function Members() {
  return (
    <>
      <center>
        <h1>Committee Members</h1>
      </center>

      <section className="section-team">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-md-8 col-lg-6">
              <div className="header-section"></div>
            </div>
          </div>

          <div className="memberCards">
            <NavLink
              to="/Sunil-babu-Kolanpaka"
              className="col-sm-6 col-lg-4 col-xl-3"
            >
              <div className="single-person">
                <div className="person-image">
                  <img src={Sunil} alt="" />
                </div>
                <div className="person-info">
                  <h3 className="full-name">Sunil Babu Kolanpaka</h3>
                  <span className="speciality">Founder SECRETARY </span>
                </div>
              </div>
            </NavLink>

            <NavLink className="col-sm-6 col-lg-4 col-xl-3">
              <div className="single-person">
                <div className="person-image">
                  <img src={Ankesh} alt="" />
                </div>
                <div className="person-info">
                  <h3 className="full-name">Ankesh Rathore</h3>
                  <span className="speciality">VICE President</span>
                </div>
              </div>
            </NavLink>
               <NavLink to="/Chetan-sharma" className="col-sm-6 col-lg-4 col-xl-3">
              <div className="single-person">
                <div className="person-image">
                  <img src={ChetaSharma} alt="" />
                </div>
                <div className="person-info">
                  <h3 className="full-name">Chetan-Sharma</h3>
                  <span className="speciality">TREASURER</span>
                </div>
              </div>
            </NavLink>
            <NavLink to="/ss-rajamouli" className="col-sm-6 col-lg-4 col-xl-3">
              <div className="single-person">
                <div className="person-image">
                  <img src={Rajamouli} alt="" />
                </div>
                <div className="person-info">
                  <h3 className="full-name">Padma Shri SS Rajamouli</h3>
                  <span className="speciality">Hon-Chairman</span>
                </div>
              </div>
            </NavLink>
            <NavLink
              to="/dilip-vengsarkar"
              className="col-sm-6 col-lg-4 col-xl-3"
            >
              <div className="single-person">
                <div className="person-image">
                  <img src={DilipV} alt="" />
                </div>
                <div className="person-info">
                  <h3 className="full-name">Padma Shri Dilip Vengsarkar</h3>
                  <span className="speciality">Mentor/Chief Advisor</span>
                </div>
              </div>
            </NavLink>
          </div>
        </div>
      </section>
    </>
  );
}

export default Members;
